module.exports = __webpack_public_path__ + "img/tpjzsb.0a6f19c7.svg";